import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m100 30 70 38v80l-70 32-70-32V68z" }, null, -1),
    _createElementVNode("path", {
      stroke: "var(--mc-avatar)",
      "stroke-width": "3",
      d: "m100 30 70 38-70 22-70-22zM100 90v90M100 90 30 68M100 90l70-22"
    }, null, -1)
  ]))]))
}
export default { render: render }